import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import { fetchAppointmentView } from "slices/appointmentSlice";
import { useDispatch, useSelector } from "react-redux";
import { SubmitButton } from "components/common/buttons/SubmitButton";
import toast from "react-hot-toast";
import { setActionAssign } from "slices/actionButtonSlice";
import CancelModal from "components/appointment/CancelModal";
import DonotCover from "components/appointment/DonotCover";
import AddVideoLink from "components/appointment/AddVideoLink";
import RescheduleModal from "components/appointment/RescheduleModal";
import { fetchAppointmentLogs } from "slices/appointmentSlice";
import LogsTable from "./LogsTable";
import { setAddAppointmentPopup } from "slices/appointmentSlice";
import { appointmentsSelector } from "slices/appointmentSlice";
import { closeAppointmentPopup } from "slices/appointmentSlice";
import { removeAppointment } from "slices/appointmentSlice";
import Swal from "sweetalert2";
import SelectInterpreterModal from "components/common/SelectInterpreterModal";
import CouldNotCover from "components/appointment/CouldNotCover";
import FullPageLoader from "components/common/FullPageLoader";
import { CheckinCheckoutAdjustmentModal } from "components/appointment/checkinCheckoutAdjustment";
import { usePermissions } from "layouts/Admin";
import AddPatient from "components/appointment/AddPatient";
import ApprovalModal from "components/appointment/ApprovalModal";
import UpdateEmailConfirmationModal from "components/appointment/UpdateEmailConfirmationModal";
import formatDateTimeByTimezone from "hooks/formatDateTimeByTimezone";
import { setIframeUrl } from "slices/iframeSlice";

// import moment from 'moment';
import ViewTable from "./ViewTable";
import moment from "moment-timezone";
import { Trash2, Video } from "lucide-react";
import Api from "services/api";
import RecordingModal from "views/JoinRoomCall/RecordingModal";
import { Controller, useFieldArray, useForm } from "react-hook-form";
import { CloseButton } from "reactstrap";
import { getCheckInStatus } from "slices/userSlice";
const AppointmentView = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { checkPermission } = usePermissions();
  const dispatch = useDispatch();
  const [item, setItem] = React.useState({});
  const [loading, setLoading] = React.useState(false);
  const [logs, setLogs] = React.useState([]);
  const [cancelModal, setCancelModal] = React.useState(false);
  const [donotCover, setDonotCover] = React.useState(false);
  const [addVideoLink, setAddVideoLink] = React.useState(false);
  const [addPatient, setAddPatient] = React.useState(false);
  const [couldNotCover, setCouldNotCover] = React.useState(false);
  const [approval, setApproval] = React.useState(false);
  const [assignInterpreter, setAssignInterpreter] = React.useState(false);
  const [rescheduleModal, setRescheduleModal] = React.useState(false);
  const [reassignEmailModalOpen, setReassignEmailModalOpen] = React.useState(false);
  const [reassignEmailPreviewHtml, setReassignEmailPreviewHtml] = React.useState('');
  const [reassignEmailPreviewSubject, setReassignEmailPreviewSubject] = React.useState('');
  const [reassignEmailPreviewButtonText, setReassignEmailPreviewButtonText] = React.useState('');
  const [reassignEmailPreviewRedirectLink, setReassignEmailPreviewRedirectLink] = React.useState('');
  const [reassignEmailAppointmentId, setReassignEmailAppointmentId] = React.useState(null);
  const [reassignEmailModalTitle, setReassignEmailModalTitle] = React.useState('Send Appointment Reassign Email');
  const [reassignEmailModalMessage, setReassignEmailModalMessage] = React.useState('The appointment has been reassigned. Choose whether to send the standard client notification email, compose a custom client email, or skip client notification.');
  const [reassignEmailSendApi, setReassignEmailSendApi] = React.useState(() => Api.sendReassignEmail);
  const [checkinCheckoutModal, setCheckinCheckoutModal] = React.useState(false);
  console.log('itemssssssss:', item);

  const { popup: appointmentPopUpState } = useSelector(appointmentsSelector);

  const location = useLocation();

  const callViewApi = async () => {
    const callBack = (success, message, data) => {
      setLoading(false);
      if (success) {
        setItem(data);
        // console.log(data)
        if (data?.client_auto_assignment_notification_status === "pending") {
          handleOpenReassignEmailModal(
            id,
            data?.standard_email_html,
            data?.standard_email_subject,
            data?.standard_email_button_text,
            data?.standard_email_redirect_link,
            "Send Appointment Email",
            "The appointment has been assigned. Choose whether to send the standard client notification email, compose a custom client email, or skip client notification.",
            Api.sendAutoAssignmentEmail
          );
        }
      } else {
        console.log(message);
      }
      // setItem()
    };

    dispatch(fetchAppointmentView(id, callBack));
  };

  const fetchLogs = async () => {
    const callBack = (success, message, data) => {
      if (success) {
        setLogs(data);
        // console.log(data)
      } else {
        console.log(message);
      }
      // setLogs()
    };
    dispatch(fetchAppointmentLogs(id, callBack));
  };

  React.useEffect(() => {
    setLoading(true);
    callViewApi();
    fetchLogs();
  }, [id, location.key]);

  const handleCancel = () => {
    setCancelModal(true);
  };
  const handleCloseCancel = () => {
    setCancelModal(false);
  };
  const handleDonotCover = () => {
    setDonotCover(true);
  };
  const handleAddVideoLink = () => {
    setAddVideoLink(true);
  };
  const handleCloseDonotCover = () => {
    setDonotCover(false);
  };
  const handleCloseAddVideoLink = () => {
    setAddVideoLink(false);
  };

  const handleAddPatient = () => {
    setAddPatient(true);
  };
  const handleCloseAddPatient = () => {
    setAddPatient(false);
  };

  const handleApproval = () => {
    setApproval(true);
  };
  const handleCloseApproval = () => {
    setApproval(false);
  };

  const handleCouldNotCover = () => {
    setCouldNotCover(true);
  };
  const handleCloseCouldNotCover = () => {
    setCouldNotCover(false);
  };
  const handleReschedule = () => {
    setRescheduleModal(true);
  };
  const handleCloseReschedule = () => {
    setRescheduleModal(false);
  };
  const handleAssignInterpreter = () => {
    setAssignInterpreter(true);
  };
  const handleCloseAssignInterpreter = () => {
    setAssignInterpreter(false);
  };
  const handleOpenReassignEmailModal = (appointmentId, html, subject, buttonText, redirectLink, title, message, sendEmailApiFn) => {
    setReassignEmailAppointmentId(appointmentId);
    setReassignEmailPreviewHtml(html || '');
    setReassignEmailPreviewSubject(subject || 'Appointment Reassigned');
    setReassignEmailPreviewButtonText(buttonText || 'View Appointment');
    setReassignEmailPreviewRedirectLink(redirectLink || '');
    setReassignEmailModalTitle(title || 'Send Appointment Reassign Email');
    setReassignEmailModalMessage(message || 'The appointment has been reassigned. Choose whether to send the standard client notification email, compose a custom client email, or skip client notification.');
    setReassignEmailSendApi(() => sendEmailApiFn || Api.sendReassignEmail);
    setReassignEmailModalOpen(true);
  };
  const handleCloseReassignEmailModal = () => {
    setReassignEmailModalOpen(false);
  };
  const handleReassignEmailComplete = () => {
    setReassignEmailModalOpen(false);
    callViewApi();
  };
  const handleOpenCheckinCheckoutModal = () => {
    setCheckinCheckoutModal(true);
  };
  const handleCloseCheckinCheckoutModal = () => {
    setCheckinCheckoutModal(false);
  };
  const handleEditAppointmentPopUp = () => {
    dispatch(
      setAddAppointmentPopup({
        show: true,
        popupType: "edit",
        item,
        callback: editFormSubmitCallback,
      })
    );
  };
  const handleCopyAppointmentPopUp = () => {
    dispatch(
      setAddAppointmentPopup({
        show: true,
        popupType: "copy",
        item,
      })
    );
  };
  const handleCloseEditApptPopup = () => {
    dispatch(closeAppointmentPopup());
  };

  const handleSubmit = (data, end_point, callBack) => {
    setLoading(true);
    const submitCallback = (success, message, responseData) => {
      callBack && callBack();
      if (success) {
        handleCloseCancel();
        handleCloseDonotCover();
        handleCloseAddVideoLink();
        handleCloseCouldNotCover();
        handleCloseReschedule();
        handleCloseAssignInterpreter();
        handleCloseEditApptPopup();
        handleCloseCheckinCheckoutModal();
        handleCloseAddPatient();
        handleCloseApproval();
        callViewApi();
        fetchLogs();
        toast.success(message, {
          className: "successToast",
        });
        if (end_point === 'reassign' && responseData?.data?.standard_email_html) {
          handleOpenReassignEmailModal(
            id,
            responseData.data.standard_email_html,
            responseData.data.standard_email_subject,
            responseData.data.standard_email_button_text,
            responseData.data.standard_email_redirect_link,
            "Send Appointment Reassign Email",
            "The appointment has been reassigned. Choose whether to send the standard client notification email, compose a custom client email, or skip client notification.",
            Api.sendReassignEmail
          );
        }
        setLoading(false);
        // scheduleDetailModal?.show && openModal()
      } else {
        toast.error(message, {
          className: "errorToast",
        });
        setLoading(false);
      }
    };
    dispatch(setActionAssign(id, data, end_point, submitCallback));
  };

  const handleSendFeedbackMail = async () => {
    if (!item?.feedback) {
      toast.error("No feedback available for this appointment.", {
        className: "errorToast",
      });
      return;
    }

    setLoading(true);
    try {
      const response = await Api.setActionAssign(id, {}, 'feedback-mail');
      if (response?.status >= 200 && response?.status < 300) {
        toast.success(response?.data?.message || 'Feedback email sent successfully.', {
          className: "successToast",
        });
        callViewApi();
        fetchLogs();
      } else {
        toast.error(response?.data?.message || 'Failed to send feedback email.', {
          className: "errorToast",
        });
      }
    } catch (error) {
      console.error(error);
      toast.error('Failed to send feedback email.', {
        className: "errorToast",
      });
    } finally {
      setLoading(false);
    }
  };

  const editFormSubmitCallback = () => {
    callViewApi();
  };

  const handleRemove = () => {
    const callBack = (success, message) => {
      if (success) {
        new Swal({
          title: message,
          icon: "success",
          timer: 2000,
          showConfirmButton: false,
        });

        navigate("/", { replace: true });
      } else {
        new Swal({
          title: message,
          icon: "error",
          timer: 2000,
          showConfirmButton: false,
        });
      }
    };
    new Swal({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(removeAppointment(id, callBack));
      }
    });
  };

  const navigateToInviteInterpreter = () => {
    // window.location.href = `/invite-interpreter/${id}`;
    navigate(`/appointments/invite-interpreter/${id}`);
  };
  const mileageCheck = (val) => {
    return item?.appointment_details?.[val];
  };

  const AppointmentTimezone = item?.appointment_details?.timezone;
  const rawDatetime = item?.datetime;

  // Date: use appointment timezone so late-night appointments don't shift the date
  const formattedDate = AppointmentTimezone?.name
    ? moment.tz(rawDatetime, AppointmentTimezone.name).format("MMM D, YYYY")
    : moment(rawDatetime).format("MMM D, YYYY");

  // Denver time: parse stored datetime as appointment tz, then convert to Denver
  const formattedDefaultTime = AppointmentTimezone?.name
    ? moment.tz(rawDatetime, AppointmentTimezone.name).tz("America/Denver").format("hh:mm A")
    : moment(rawDatetime).format("hh:mm A");

  // Appointment timezone time: parse as appointment tz and label it
  const formattedClientTime = (() => {
    if (!AppointmentTimezone?.name) return formattedDefaultTime;
    const m = moment.tz(rawDatetime, AppointmentTimezone.name);
    // const abbr = AppointmentTimezone.abbreviation;
    // const offset = AppointmentTimezone.utc_offset;
    // const zone = abbr ? `(${abbr} / GMT${offset})` : `(GMT${offset})`;
    const dynamicAbbr = m.format("z");
    const dynamicOffset = m.format("Z");
    
    const zone = dynamicAbbr ? `(${dynamicAbbr} / GMT${dynamicOffset})` : `(GMT${dynamicOffset})`;
    return `${m.format("hh:mm A")} ${zone}`;
  })();

  const [recordingUrl, setRecordingUrl] = React.useState(null);
  const [showModal, setShowModal] = React.useState(false);

  const [checkinStatus, setCheckinStatus] = useState(0);
  
    useEffect(() => {
      dispatch(
        getCheckInStatus((success, data) => {
          if (success) {
            setCheckinStatus(data?.data?.user?.checked_in);
          } else {
            console.log("Failed to fetch check-in status", data);
          }
        })
      );
    }, [dispatch]);
  
  //   Join Video Call handler
  const handleJoinVideoCall = async () => {
    if (checkinStatus !== 1) {
      toast.error("Please check in first before joining the video call.", {
        className: "errorToast",
      });
      return;
    }

    if (
      item?.appointment_details?.video_platform === "external" &&
      item?.appointment_details?.video_link
    ) {
      window.open(item.appointment_details.video_link, "_blank");
      return;
    }

    try {
      const response = await Api.adminjoinVideoCall(id);
      if (response?.status === 200) {
        const iframeUrl = response?.data?.data?.iframe_url;
        dispatch(setIframeUrl(iframeUrl));
        navigate(`/appointments/view/join-room-call/${id}`);
        // console.log("Joined successfully:", response?.data?.data?.iframe_url);
        // console.log("Joined successfully:", response);
      } else {
        const errorMsg =
          response?.data?.statusText ||
          response?.data?.message ||
          response?.data?.error;
        console.error("Failed to join:", errorMsg);
        toast.error(errorMsg, { className: "errorToast" });
      }
    } catch (err) {
      console.error("Error joining video call:", err);
      toast.error("Error joining video call.", { className: "errorToast" });
    }
  };

  const showRecordingPopup = () => {
    if (item?.appointment_details?.recording) {
      setRecordingUrl(item.appointment_details.recording);
      setShowModal(true);
    } else {
      toast.error("Recording not available for this appointment.", {
        className: "errorToast",
      });
    }
  };

  const [inviteGuestPopup, setInviteGuestPopup] = React.useState({
    open: false,
    documents: [],
  });

  // Invites Guest Popup
  const InviteGuestPopup = ({ open, item, onClose, appointmentId }) => {
    const [loading, setLoading] = useState(false);
    const {
      control,
      handleSubmit,
      formState: { errors },
    } = useForm({
      defaultValues: {
        emailArray: item?.appointment_details?.requester_email
          ? item.appointment_details.requester_email
              .split(",")
              .map((email) => ({ email: email.trim() }))
          : [{ email: "" }],
      },
    });

    const { fields, append, remove } = useFieldArray({
      control,
      name: "emailArray",
    });

    const onSubmit = async (data) => {
      const emails = data.emailArray
        .map((item) => item.email.trim())
        .filter(Boolean);
      // console.log("Emails to send:", emails);

      try {
        setLoading(true);
        const payload = { requester_email: emails };
        const response = await Api.inviteGuests(appointmentId, payload);
        console.log("res", response);
        toast.success(response?.data?.message);
        setLoading(false);
        setInviteGuestPopup({
          open: false,
          documents: [],
        });
        callViewApi();
      } catch (error) {
        setLoading(false);
        console.log("error", error);
      }
    };

    if (!open) return null;

    return (
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          background: "rgba(0,0,0,0.3)",
          zIndex: 9999,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: 20,
          boxSizing: "border-box",
        }}
      >
        <form
          onSubmit={handleSubmit(onSubmit)}
          style={{
            background: "#fff",
            borderRadius: 12,
            minWidth: 500,
            maxWidth: 900,
            width: "40%",
            maxHeight: "100%",
            padding: 32,
            boxShadow: "0 4px 24px rgba(0,0,0,0.15)",
            position: "relative",
            overflowY: "auto",
          }}
        >
          <button
            style={{
              position: "absolute",
              top: 16,
              right: 16,
              background: "none",
              border: "none",
              fontSize: 22,
              cursor: "pointer",
            }}
            onClick={onClose}
            aria-label="Close"
            type="button"
          >
            <CloseButton style={{ width: 10, height: 10 }} />
          </button>
          <h2 style={{ marginBottom: 24 }}>Invite Guests</h2>

          {/* Render dynamic email inputs */}
          {fields.map((field, index) => (
            <div key={field.id} className="w-100 row-primary">
              <Controller
                name={`emailArray.${index}.email`}
                control={control}
                rules={{
                  required: "Email is required",
                  pattern: {
                    value: /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/,
                    message: "Invalid email format",
                  },
                }}
                defaultValue={field.email}
                render={({ field }) => (
                  <input
                    className="input-in type_inp"
                    {...field}
                    type="email"
                    placeholder="Email"
                    style={{ flexGrow: 1, marginRight: 8 }}
                  />
                )}
              />
              <button
                type="button"
                onClick={() => remove(index)}
                style={{
                  background: "red",
                  color: "white",
                  border: "none",
                  borderRadius: 8,
                  padding: "6px 14px",
                  cursor: "pointer",
                }}
              >
                <Trash2 style={{ width: 16, height: 16 }} />
              </button>
            </div>
          ))}

          {/* Show validation error for each email */}
          {errors.emailArray &&
            errors.emailArray.map((error, idx) =>
              error?.email ? (
                <div
                  key={idx}
                  style={{ color: "red", marginBottom: 10, fontSize: 12 }}
                >
                  {error.email.message}
                </div>
              ) : null
            )}

          <div
            style={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginTop: 20,
            }}
          >
            <button
              type="button"
              onClick={() => append({ email: "" })}
              style={{
                padding: "10px 16px",
                borderRadius: 6,
                border: "1px solid #888",
                background: "white",
                cursor: "pointer",
              }}
            >
              Add Email
            </button>

            <SubmitButton
              buttonType="submit"
              className={"button"}
              btnText="Send Invite"
              disabled={loading}
              loader={loading}
            />
          </div>
        </form>
      </div>
    );
  };

  return (
    <div className="content" style={{}}>
      {loading && <FullPageLoader />}
      {/* <did */}
      <div className="row_main_head bg-primary-secondaryCard">
        <h2 className={`main_heading main_heading1`}>
          View Appointment # {item?.appid}
        </h2>
        <div className="mb-3">
          <div className="text-transform-capitalize main_heading main_heading1">
            Client : {item?.accounts?.user?.name}
          </div>
        </div>
      </div>
      <div className="row_main_head bg-light-secondaryCard mt-3">
        <h2 className={`main_heading2 view-page`} toLowerCase={"text-lowercase"}>
          Date <span className="dateTime viewpage_tags">{formattedDate}</span> /{" "}
          <span className="dateTime viewpage_tags">{formattedDefaultTime}</span> OR{" "}
          <span className="dateTime viewpage_tags">{formattedClientTime}</span>
        </h2>
        <div className="">
          <div className="text-transform-capitalize main_heading2 d-flex align-items-center">
            <span className="appointmentType viewpage_tags">{item?.type}</span>{" "}
            <span className="appLanguage viewpage_tags">{item?.language?.name}</span>
          </div>
        </div>
      </div>
      <div className="card_table view_table_custom">
        {mileageCheck("extra_mileage") &&
        mileageCheck("extra_mileage_request") == null ? (
          <div className="row_main_head align-items-center softAlert waiting">
            <h3>The vendor has requested extra mileage</h3>
            {checkPermission("Extra Mileage") && (
              <SubmitButton
                buttonType="button"
                className={"green"}
                btnText="View Request"
                handleSubmit={handleApproval}
              />
            )}
          </div>
        ) : mileageCheck("extra_mileage") &&
          mileageCheck("extra_mileage_request") == 1 ? (
          <div className="softAlert approved">
            <h3>
              The extra mileage request for this appointment have been approved.
            </h3>
          </div>
        ) : mileageCheck("extra_mileage") &&
          mileageCheck("extra_mileage_request") == 0 ? (
          <div className="softAlert rejected">
            <h3>
              The extra mileage request for this appointment have been rejected.
            </h3>
          </div>
        ) : (
          ""
        )}

        {/* <div className="row_main_head">
                    <h2 className={`main_heading`}>View Appointment # {item?.appid}</h2>
                    <div className='mb-3'>
                        <div className='text-transform-capitalize main_heading' >
                            Status : {item?.status}
                        </div>
                    </div>
                </div> */}

        <div className="row-primary flex-wrap justify-content-between">
          <div className="row-primary flex-wrap">
            {checkPermission("Copy Appointment") && (
              <SubmitButton
                buttonType="button"
                className={"lightPurple"}
                btnText="Copy"
                handleSubmit={handleCopyAppointmentPopUp}
              />
            )}
            {checkPermission("Assign Appointment") && item?.status != "completed" && item?.status != "cancelled" && (
              <SubmitButton
                buttonType="button"
                className={"green"}
                btnText={item?.status === "assigned" ? "Reassign":"Assign"}
                handleSubmit={handleAssignInterpreter}
              />
            )}
            {checkPermission("Edit Appointments") && item?.status != "completed" && item?.status != "cancelled" && (
              <SubmitButton
                buttonType="button"
                className={"lightGrey"}
                btnText="Edit"
                handleSubmit={handleEditAppointmentPopUp}
              />
            )}
            {checkPermission("Reschedule Appointment") && item?.status != "completed" && item?.status != "cancelled" && (
              <SubmitButton
                buttonType="button"
                className={"lightBlue"}
                btnText="Reschedule"
                handleSubmit={handleReschedule}
              />
            )}
            {checkPermission("Donot Cover") && item?.status != "completed" && item?.status != "cancelled" && item?.status !== "DNC" && (
              <SubmitButton
                buttonType="button"
                btnText="Do Not Cover"
                className="yellow"
                handleSubmit={handleDonotCover}
              />
            )}
            {checkPermission("Add Video Link") && item?.status != "completed" && item?.status != "cancelled" && item?.type == "Video Remote Interpretation" && item.appointment_details.video_platform == 'external' && (
              <SubmitButton
                buttonType="button"
                btnText={item?.appointment_details?.video_link ? "Edit Video Link" : "Add Video Link"}
                className="primary"
                handleSubmit={handleAddVideoLink}
              />
            )}
            {checkPermission("Could Not Cover") && item?.status != "completed" && item?.status != "cancelled" && item?.status !== "CNC" && (
              <SubmitButton
                buttonType="button"
                btnText="Could Not Cover"
                className="yellow"
                handleSubmit={handleCouldNotCover}
              />
            )}
            {checkPermission("Cancel Appointment") && item?.status != "completed" &&
              item?.status !== "cancelled" && (
                <SubmitButton
                  buttonType="button"
                  className={"tomatoRed"}
                  btnText="Cancel"
                  handleSubmit={handleCancel}
                />
              )}
            {checkPermission("Check-in/Check-out") && item?.status == "assigned" && !(item?.type === "Video Remote Interpretation" && item?.appointment_details?.video_platform === "external" && !item?.appointment_details?.video_link) && (
              <SubmitButton
                buttonType="button"
                className="Cancle_button"
                btnText="Checkin / checkout"
                handleSubmit={handleOpenCheckinCheckoutModal}
              />
            )}
            {checkPermission("Invite Interpreter") &&
              item?.status == "available" && (
                <SubmitButton
                  buttonType="button"
                  className={"green"}
                  btnText="Invite Vendors"
                  handleSubmit={navigateToInviteInterpreter}
                />
              )}
            {item?.type == "OPI On Demand" && item?.status != "cancelled" && (
              <SubmitButton
                buttonType="button"
                btnText="Add Patient"
                handleSubmit={handleAddPatient}
              />
            )}
          </div>

          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            {item.type === "Video Remote Interpretation" && item?.status != "completed" && item?.status != "cancelled" && (
              <SubmitButton
                style={{ padding: "16px 14px" }}
                className="Cancle_button"
                btnText="Invite Guests"
                handleSubmit={() =>
                  setInviteGuestPopup({
                    open: true,
                    documents: [], // ya jo default chahiye
                  })
                }
              />
            )}

            {/* Join Video Call Button  */}
            {item.type === "Video Remote Interpretation" && item?.status != "completed" && item?.status != "cancelled" && (item?.appointment_details?.video_platform === "algovi" ||(item?.appointment_details?.video_platform === "external" && !!item?.appointment_details?.video_link)) && (
              <SubmitButton
                className="green"
                btnText="Join Video Call"
                icon={<Video />}
                handleSubmit={handleJoinVideoCall}
              />
            )}
          </div>
        </div>

        <ViewTable item={item} />
        {item?.appointment_details?.feedback_mail_sent === 0 && item?.feedback && item?.status == "completed" && (
          <SubmitButton
            buttonType="button"
            className={"blue"}
            btnText="Send Feedback to Interpreter"
            handleSubmit={handleSendFeedbackMail}
          />
        )}
        <div className="d-flex gap-2 justify-content-end mt-3">
          {/* {checkPermission('Delete Appointments') &&
                        <SubmitButton buttonType="button" className={'tomatoRed'} btnText="Remove this Appointment" handleSubmit={handleRemove} />
                    } */}

          {/* View Recording Button  */}
          {item?.appointment_details?.recording && (
            <SubmitButton
              className="Cancle_button"
              btnText="View Recording"
              handleSubmit={showRecordingPopup}
            />
          )}
        </div>
      </div>

      <div className="card_table p-4">
        <div className="row_main_head mb-3">
          <h2 className={`main_heading`}>Appointment Logs</h2>
        </div>
        <LogsTable logs={logs} />
      </div>

      <SelectInterpreterModal
        isOpen={assignInterpreter}
        onClose={handleCloseAssignInterpreter}
        onConfirm={handleSubmit}
        appointmentId={id}
        items={item}
        loader={loading}
        previewEmailOnSubmit={true}
        endpoint={item?.status === "assigned" ? "reassign" : "assign"}
      />

      <UpdateEmailConfirmationModal
        show={reassignEmailModalOpen}
        handleClose={handleCloseReassignEmailModal}
        appointmentId={reassignEmailAppointmentId}
        standardHtml={reassignEmailPreviewHtml}
        onComplete={handleReassignEmailComplete}
        // modalTitle="Send Appointment Reassign Email"
        // modalMessage="The appointment has been reassigned. Choose whether to send the standard client notification email, compose a custom client email, or skip client notification."
        modalTitle={reassignEmailModalTitle}
        modalMessage={reassignEmailModalMessage}
        sendEmailApi={reassignEmailSendApi}
      />

      <CancelModal
        isOpen={cancelModal}
        onClose={handleCloseCancel}
        onConfirm={handleSubmit}
        appointmentId={id}
        item={item}
        loader={loading}
      />
      <DonotCover
        isOpen={donotCover}
        onClose={handleCloseDonotCover}
        onConfirm={handleSubmit}
        appointmentId={id}
        item={item}
        loader={loading}
      />
      <AddVideoLink
        isOpen={addVideoLink}
        onClose={handleCloseAddVideoLink}
        onConfirm={handleSubmit}
        appointmentId={id}
        item={item}
        loader={loading}
      />
      <AddPatient
        isOpen={addPatient}
        onClose={handleCloseAddPatient}
        onConfirm={handleSubmit}
        appointmentId={id}
        item={item}
        loader={loading}
      />
      <CouldNotCover
        isOpen={couldNotCover}
        onClose={handleCloseCouldNotCover}
        onConfirm={handleSubmit}
        appointmentId={id}
        item={item}
        loader={loading}
      />

      <RescheduleModal
        isOpen={rescheduleModal}
        onClose={handleCloseReschedule}
        onConfirm={handleSubmit}
        appointmentId={id}
        item={item}
        loader={loading}
      />

      <CheckinCheckoutAdjustmentModal
        isOpen={checkinCheckoutModal}
        handleClose={handleCloseCheckinCheckoutModal}
        onConfirm={handleSubmit}
        appointmentId={id}
        onSubmit={handleSubmit}
        item={item}
        loader={loading}
        targetTimezone={AppointmentTimezone?.name}
      />
      <ApprovalModal
        isOpen={approval}
        onClose={handleCloseApproval}
        onConfirm={handleSubmit}
        appointmentId={id}
        item={item}
        loader={loading}
      />
      <RecordingModal
        recordingUrl={recordingUrl}
        showModal={showModal}
        onClose={() => setShowModal(false)}
      />

      <InviteGuestPopup
        appointmentId={id}
        open={inviteGuestPopup.open}
        item={item}
        onClose={() => setInviteGuestPopup({ open: false, documents: [] })}
      />
    </div>
  );
};

export default AppointmentView;
